import { CardContent, Typography } from "@mui/material";
import Grid from "@mui/material/Grid";
import React from "react";

import CandidateCardHeader from "./CandidateCardHeader";

export default function CandidateMovieRoot({
  candidateRoot,
  actionTypes,
  candidateTypes,
  onHide,
  onRootActionIconClick,
  onCandidateRootTypeOptionChange,
}) {
  return (
    <CardContent style={{ paddingBottom: 0 }}>
      <Grid container spacing={1} justifyContent="space-between" alignItems="center">
        <CandidateCardHeader
          candidateRoot={candidateRoot}
          actionTypes={actionTypes}
          candidateTypes={candidateTypes}
          onHide={onHide}
          onRootActionIconClick={onRootActionIconClick}
          onCandidateRootTypeOptionChange={onCandidateRootTypeOptionChange}
        />

        <Grid size={12}>
          <Typography
            variant="body1"
            color="textSecondary"
            component="p"
            style={{ overflowWrap: "break-word" }}
          >
            {candidateRoot.path.substring(candidateRoot.mediaRootPath.length)}
          </Typography>
        </Grid>
      </Grid>
    </CardContent>
  );
}
